import type { CellState } from "@/lib/availability/cell-state";
import { cn } from "@/lib/utils";
import { CHIP_CLASS } from "./cell-style";
import { STATE_LABEL } from "./labels";

const CHIP_BASE =
  "inline-flex shrink-0 items-center rounded-full px-1.5 py-px font-mono text-xs font-medium tracking-wide uppercase";

/** CHRONIC / ROLLING OFF / NON-DELIVERY beside a person's name. */
export function RowChip({ kind }: { kind: "chronic" | "rollingOff" | "nonDelivery" }) {
  if (kind === "chronic") {
    return (
      <span
        title="Over-utilized or Stretched for 3 or more months in a row"
        className={cn(
          CHIP_BASE,
          "bg-[var(--avail-stretched)] text-[color:var(--avail-stretched-fg)]",
        )}
      >
        Chronic
      </span>
    );
  }
  if (kind === "rollingOff") {
    return (
      <span
        title="Booked hours drop by 40 or more within 60 days"
        className={cn(
          CHIP_BASE,
          "bg-[var(--avail-some-room)] text-[color:var(--avail-some-room-fg)]",
        )}
      >
        Rolling off
      </span>
    );
  }
  return (
    <span
      title="This Home Role is not staffed onto Solutions"
      className={cn(
        CHIP_BASE,
        "border border-[color:var(--avail-unplanned-border)] text-[color:var(--avail-nodata-fg)]",
      )}
    >
      Non-delivery
    </span>
  );
}

/** The cell's state as a pill, for the drill-in panels. */
export function StateChip({ state }: { state: CellState }) {
  return (
    <span
      className={cn(
        "inline-flex h-6 items-center rounded-full px-2.5 font-mono text-xs font-medium tracking-wide uppercase",
        CHIP_CLASS[state],
      )}
    >
      {STATE_LABEL[state]}
    </span>
  );
}

/** An amber corner, drawn as a clipped square so it needs no border tricks. */
export function IssueCorner({ className }: { className?: string }) {
  return (
    <span
      aria-hidden
      className={cn(
        "pointer-events-none absolute top-0 right-0 size-3 bg-[var(--avail-issue)] [clip-path:polygon(0_0,100%_0,100%_100%)]",
        className,
      )}
    />
  );
}
